import { createFileRoute } from "@tanstack/react-router"

import { CandidateScreener } from "@/pages/CandidateScreener"

export const Route = createFileRoute("/hr/screener")({
  component: CandidateScreener,
})
